import { reduceFeaturesResponse } from 'pricing-pages-lib/reducers/Features';
import { FetchFeaturesRequestTypes } from '../actions/FeatureActions';
const initialState = {
  features: {},
  highlightedProducts: {}
};

const Features = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchFeaturesRequestTypes.RECEIVE:
      {
        const data = payload && payload.data;
        const productLine = payload && payload.props && payload.props.productLine;
        const highlightedProducts = payload && payload.props && payload.props.highlightedProducts;

        if (data && productLine && highlightedProducts) {
          return reduceFeaturesResponse({
            data,
            productLine,
            highlightedProducts,
            state: state
          });
        }

        return state;
      }

    default:
      return state;
  }
};

export default Features;